var _path, _path2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConvertIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_278_37684)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4924 19.9136C11.9077 21.1228 15.8039 20.5359 18.7172 18.1317L19.7778 19.1924C15.0614 23.1875 7.99743 22.9683 3.54973 18.5206C3.38709 18.358 3.25274 18.1954 3.10425 18.0327L8.49948 18.0257L8.4924 19.9136ZM20.4496 5.47936C20.6122 5.642 20.7466 5.80463 20.888 5.97434L15.4998 5.97434L15.4998 4.09343C12.0916 2.87721 8.19542 3.46411 5.28214 5.86827L4.22148 4.80761C8.93788 0.812461 16.0019 1.03166 20.4496 5.47936Z",
    fill: "#DEDEDE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_278_37684",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 5,
    width: 12,
    height: 12
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H6V17H18V5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_278_37684)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0962 10C12.4918 10 12.8784 9.8827 13.2073 9.66294C13.5362 9.44318 13.7926 9.13082 13.9439 8.76537C14.0953 8.39992 14.1349 7.99778 14.0578 7.60982C13.9806 7.22186 13.7901 6.86549 13.5104 6.58579C13.2307 6.30608 12.8743 6.1156 12.4864 6.03843C12.0984 5.96126 11.6963 6.00087 11.3308 6.15224C10.9654 6.30362 10.653 6.55996 10.4332 6.88886C10.2135 7.21776 10.0962 7.60444 10.0962 8C10.0962 8.53043 10.3069 9.03914 10.682 9.41421C11.057 9.78929 11.5658 10 12.0962 10ZM7.42969 16C7.42969 14.7623 7.92136 13.5753 8.79655 12.7001C9.67173 11.8249 10.8587 11.3333 12.0964 11.3333C13.3341 11.3333 14.5211 11.8249 15.3963 12.7001C16.2715 13.5753 16.7632 14.7623 16.7632 16H7.42969Z",
    fill: "#DEDEDE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_278_37684"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConvertIcon);
export default __webpack_public_path__ + "static/media/convertIcon.3051170e243724fa1b05b532f8529e77.svg";
export { ForwardRef as ReactComponent };